<template>
  <NarrowContainer>
    <div class="category-layout" data-testid="category-layout">
      <div class="top-content-category">
        <div class="title-search-result">
          {{ $t('categories.searchResult') }}
        </div>
        <h1 class="category-name">{{ title }}</h1>
        <div class="description-top-category">
          <div v-html="description"></div>
        </div>
        <ul class="list-sub-category" v-if="subCategories && subCategories.length">
          <li v-for="(subCategory, index) in subCategories" :key="index">
            <nuxt-link :to="subCategory.href" class="subcategory-link">
              {{ subCategory.name }}
            </nuxt-link>
          </li>
        </ul>

        <button class="filter-actions" @click="toggleSidebar">
          <span>{{ isOpen ? $t('categories.hideFilters') : $t('categories.showFilters') }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_4007_1493)">
              <path
                d="M11.7333 0.000457764C11.4504 0.000461134 11.179 0.112811 10.9789 0.312791C10.7788 0.512771 10.6664 0.784 10.6664 1.06681V1.60051H1.06698C0.784005 1.60051 0.512621 1.71285 0.312525 1.91282C0.112429 2.11279 1.12338e-05 2.38401 0 2.66681C-1.27979e-06 2.80685 0.0275959 2.94551 0.081216 3.07489C0.134836 3.20426 0.213429 3.32181 0.312507 3.42083C0.411585 3.51985 0.529208 3.5984 0.658661 3.65199C0.788114 3.70558 0.92686 3.73316 1.06698 3.73317H10.6664V4.26749C10.6664 4.5503 10.7788 4.82153 10.9789 5.02151C11.179 5.22149 11.4504 5.33384 11.7333 5.33384C12.0163 5.33384 12.2877 5.22149 12.4878 5.02151C12.6879 4.82153 12.8003 4.5503 12.8003 4.26749V3.73317H14.933C15.0731 3.73317 15.2118 3.70559 15.3413 3.65201C15.4708 3.59842 15.5884 3.51987 15.6875 3.42085C15.7866 3.32183 15.8652 3.20428 15.9188 3.0749C15.9724 2.94552 16 2.80685 16 2.66681C16 2.52678 15.9724 2.38812 15.9188 2.25874C15.8651 2.12937 15.7865 2.01182 15.6875 1.9128C15.5884 1.81379 15.4707 1.73525 15.3413 1.68166C15.2118 1.62808 15.0731 1.6005 14.933 1.60051H12.8003V1.06681C12.8003 0.784 12.6879 0.512771 12.4878 0.312791C12.2877 0.112811 12.0163 0.000461134 11.7333 0.000457764ZM4 5.33379C3.85988 5.33379 3.72112 5.36136 3.59167 5.41495C3.46221 5.46854 3.34458 5.54708 3.2455 5.64611C3.14641 5.74513 3.06781 5.86268 3.01419 5.99206C2.96057 6.12144 2.93297 6.26011 2.93297 6.40015V6.93379H1.06729C0.927173 6.93379 0.788426 6.96138 0.658973 7.01497C0.529521 7.06856 0.411898 7.1471 0.312819 7.24612C0.213741 7.34514 0.135148 7.4627 0.0815285 7.59207C0.0279084 7.72145 0.000311202 7.86011 0.000312495 8.00014C0.000311202 8.14018 0.0279084 8.27884 0.0815285 8.40822C0.135148 8.53759 0.213741 8.65515 0.312819 8.75417C0.411898 8.85319 0.529521 8.93174 0.658973 8.98532C0.788426 9.03891 0.927173 9.0665 1.06729 9.0665H2.93297V9.60082C2.93297 9.74086 2.96057 9.87953 3.01419 10.0089C3.06781 10.1383 3.14641 10.2558 3.2455 10.3549C3.34458 10.4539 3.46221 10.5324 3.59167 10.586C3.72112 10.6396 3.85988 10.6672 4 10.6672C4.28298 10.6672 4.55437 10.5548 4.75447 10.3548C4.95457 10.1549 5.06698 9.88363 5.06698 9.60082V9.0665H14.9333C15.0735 9.0665 15.2122 9.03891 15.3417 8.98532C15.4711 8.93174 15.5887 8.85319 15.6878 8.75417C15.7869 8.65515 15.8655 8.53759 15.9191 8.40822C15.9727 8.27884 16.0003 8.14018 16.0003 8.00014C16.0003 7.86011 15.9727 7.72145 15.9191 7.59207C15.8655 7.4627 15.7869 7.34514 15.6878 7.24612C15.5887 7.1471 15.4711 7.06856 15.3417 7.01497C15.2122 6.96138 15.0735 6.93379 14.9333 6.93379H5.06698V6.40015C5.06698 6.11733 4.95457 5.8461 4.75447 5.64612C4.55437 5.44614 4.28298 5.33379 4 5.33379ZM7.46667 10.6672C7.18369 10.6672 6.91231 10.7795 6.71221 10.9795C6.51212 11.1795 6.3997 11.4507 6.39969 11.7335V12.2671H1.06729C0.927173 12.2671 0.788426 12.2947 0.658973 12.3483C0.529521 12.4019 0.411898 12.4804 0.312819 12.5795C0.213741 12.6785 0.135148 12.796 0.0815285 12.9254C0.0279084 13.0548 0.000311202 13.1934 0.000312495 13.3335C0.000323749 13.6163 0.112742 13.8875 0.312838 14.0875C0.512934 14.2874 0.784318 14.3998 1.06729 14.3998H6.39969V14.9342C6.3997 15.217 6.51212 15.4882 6.71221 15.6881C6.91231 15.8881 7.18369 16.0005 7.46667 16.0005C7.74964 16.0005 8.02102 15.8881 8.22112 15.6881C8.42122 15.4882 8.53363 15.217 8.53365 14.9342V14.3998H14.9333C15.2163 14.3998 15.4877 14.2874 15.6878 14.0875C15.8879 13.8875 16.0003 13.6163 16.0003 13.3335C16.0003 13.1934 15.9727 13.0548 15.9191 12.9254C15.8655 12.796 15.7869 12.6785 15.6878 12.5795C15.5887 12.4804 15.4711 12.4019 15.3417 12.3483C15.2122 12.2947 15.0735 12.2671 14.9333 12.2671H8.53365V11.7335C8.53363 11.4507 8.42122 11.1795 8.22112 10.9795C8.02102 10.7795 7.74964 10.6672 7.46667 10.6672Z"
                fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0_4007_1493">
                <rect width="16" height="16" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>

      <div :class="['category-page-content', { 'md:!pl-0': isOpen }]" data-testid="category-page-content">
        <CategorySidebar :is-open="isOpen" @close="close">
          <NuxtLazyHydrate when-visible>
            <slot name="sidebar"/>
          </NuxtLazyHydrate>
        </CategorySidebar>
        <div class="flex-1 product-listing">
          <section
            v-if="products"
            class="grid grid-cols-1 md:grid-cols-2 gap-5 xl:gap-x-[44px] xl:gap-y-[49px] md:grid-cols-2 lg:grid-cols-3 product-grid"
            :class="[{ 'active !grid-cols-1 lg:!grid-cols-2 xl:!grid-cols-3 xl:!gap-x-[25px] xl:!gap-y-[30px]': isOpen }]"
            data-testid="category-grid"
          >
            <NuxtLazyHydrate
              when-visible
              v-for="({ id, name, rating, price, primaryImage, slug, sku, gallery, description }, index) in products"
              :key="id"
            >
              <UiProductCard
                :name="name ?? ''"
                :sku="sku ?? ''"
                :rating-count="rating?.count"
                :rating="rating?.average"
                :price="price?.value.amount"
                :image-url="primaryImage?.url ?? ''"
                :image-alt="primaryImage?.alt ?? ''"
                :slug="slug"
                :priority="index === 0"
                :gallery="gallery ?? []"
                :description="description ?? ''"
              />
            </NuxtLazyHydrate>
          </section>
          <LazyCategoryEmptyState v-else/>
          <div class="flex justify-end">
            <UiPagination
              v-if="totalProducts > itemsPerPage"
              :current-page="currentPage"
              :total-items="totalProducts"
              :page-size="itemsPerPage"
              :max-visible-pages="maxVisiblePages"
            />
          </div>
        </div>
      </div>
    </div>
  </NarrowContainer>
</template>

<script setup lang="ts">
import {ref, computed} from 'vue';
import {SfButton, SfIconTune} from '@storefront-ui/vue';
import {whenever} from '@vueuse/core';
import type {CategoryPageContentProps} from '~/components/CategoryPageContent/types';

withDefaults(defineProps<CategoryPageContentProps>(), {
  itemsPerPage: 9,
});
const isOpen = ref(false);
const toggleSidebar = () => {
  isOpen.value = !isOpen.value;
};

const {isTablet, isDesktop} = useBreakpoints();
const maxVisiblePages = computed(() => (isDesktop.value ? 5 : 1));

whenever(isTablet, () => {
  isOpen.value = false;
});
</script>
